import React from 'react'
import Link from 'next/link'

import { LOCATION_TYPES } from 'utils/DirectoryParser'
import { FlexDiv, P } from 'components/generic/HomePageComponents'
import { PHover } from 'components/Directories/SearchFacetsContainer/Styled'
import LocationDropdown from './LocationDropdown'
import PostalCodeInput from './PostalCodeInput'
import { FetchLocationList, GetSelectedLocation } from './Utils'

const LocationsContainer = ({
  locationOptions,
  directoryLinkInformation,
  postalCodeUpdate,
  postalRadiusUpdate,
  invalidPostalCode,
  nearestLocation,
}) => {
  const countriesObject = locationOptions.find((option) => option.name === LOCATION_TYPES.COUNTRIES)
  const countries = FetchLocationList(locationOptions, countriesObject)
  const selectedCountry = GetSelectedLocation(countries)
  const selectedCountryName = selectedCountry && selectedCountry.name

  const statesObject = locationOptions.find((option) => option.name === LOCATION_TYPES.STATES)
  const states = FetchLocationList(locationOptions, statesObject)
  const selectedState = GetSelectedLocation(states)
  const selectedStateName = selectedState && selectedState.name

  const citiesObject = locationOptions.find((option) => option.name === LOCATION_TYPES.CITIES)
  const cities = FetchLocationList(locationOptions, citiesObject)
  const selectedCity = GetSelectedLocation(cities)
  const selectedCityName = selectedCity && selectedCity.name

  const neighborhoodsObject = locationOptions.find(
    (option) => option.name === LOCATION_TYPES.NEIGHBORHOODS
  )
  const neighborhoods = FetchLocationList(locationOptions, neighborhoodsObject)
  const selectedNeighborhood = GetSelectedLocation(neighborhoods)
  const selectedNeighborhoodName = selectedNeighborhood && selectedNeighborhood.name

  return (
    <>
      <FlexDiv margin='25px 0px 10px' justifyContent='space-between'>
        <P lineHeight='20px' fontWeight='bold' fontSize='14px'>
          Location
        </P>
        {nearestLocation && (
          <Link
            scroll={false}
            href={(nearestLocation && nearestLocation.slug) || ''}
            as={(nearestLocation && nearestLocation.slug) || ''}
          >
            <PHover>{`Search In ${
              (nearestLocation && nearestLocation.name) || 'Your Area'
            }`}</PHover>
          </Link>
        )}
      </FlexDiv>
      <LocationDropdown
        directoryLinkInformation={directoryLinkInformation}
        directoryLinkLocationInformation={{
          type: LOCATION_TYPES.COUNTRIES,
        }}
        locations={countries}
        selectedLocation={selectedCountryName}
      />
      {states && states.length > 0 && (
        <LocationDropdown
          directoryLinkInformation={directoryLinkInformation}
          directoryLinkLocationInformation={{
            type: LOCATION_TYPES.STATES,
            country: selectedCountry && selectedCountry.slug,
          }}
          locations={states}
          selectedLocation={selectedStateName}
          showSearchInput={true}
        />
      )}
      {cities && cities.length > 0 && (
        <LocationDropdown
          directoryLinkInformation={directoryLinkInformation}
          directoryLinkLocationInformation={{
            type: LOCATION_TYPES.CITIES,
            country: selectedCountry && selectedCountry.slug,
            state: selectedState && selectedState.slug,
          }}
          locations={cities}
          selectedLocation={selectedCityName}
          showSearchInput={true}
        />
      )}
      {neighborhoods && neighborhoods.length > 1 && (
        <LocationDropdown
          directoryLinkInformation={directoryLinkInformation}
          directoryLinkLocationInformation={{
            type: LOCATION_TYPES.NEIGHBORHOODS,
            country: selectedCountry && selectedCountry.slug,
            state: selectedState && selectedState.slug,
            city: selectedCity && selectedCity.slug,
          }}
          locations={neighborhoods}
          selectedLocation={selectedNeighborhoodName}
          showSearchInput={true}
        />
      )}
      <PostalCodeInput
        currentCountry={selectedCountry}
        postalCodeUpdate={postalCodeUpdate}
        postalRadiusUpdate={postalRadiusUpdate}
        invalidPostalCode={invalidPostalCode}
      />
    </>
  )
}

export default LocationsContainer
